














import { Vue, Component, Prop } from 'vue-property-decorator'
@Component
export default class NextButton extends Vue {
  @Prop() private valid!: boolean
  @Prop() private btnText!: string
  @Prop() private toolTipText!: string

  private extra = 'extra'

  private clickHandler () {
    this.$emit('next')
  }
}
